import React from 'react';
import { exposeWrapped } from '@/utils';
const AreaContext = React.createContext(null);
export default AreaContext;
export const withArea = exposeWrapped((Component) => (props) => (<AreaContext.Consumer>{(area) => <Component {...props} area={area}/>}</AreaContext.Consumer>));
